(() => {
  if (customElements.get("categories-section")) return;

  class CategoriesSection extends HTMLElement {
    constructor() {
      super();

      this.swiperEl = this.querySelector(".swiper");
    }

    connectedCallback() {
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 2.5,
        spaceBetween: 8,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 5,
          },
        },
      });
    }
  }

  customElements.define("categories-section", CategoriesSection);
})();
